import React from "react";
import "./AddSeller.css";
import { useState } from "react";
import axios from "axios";
import toastify from "../../Util/toastify";
import BaseURL from "../../Util/BaseURL";
const AddSeller = () => {
  const [sellerId, setSellerId] = useState();
  const [businessName, setBusinessName] = useState();
  const [ownerName, setOwnerName] = useState();
  const [aadharNumber, setAadharNumber] = useState();
  const [phNumber, setPhNumber] = useState();
  const [email, setEmail] = useState();
  const [address, setAddress] = useState();
  const [userPassword, setUserPassword] = useState();

  async function getSeller() {
    const response = await axios.get(`${BaseURL}FindByName?name=${sellerId}`);
    return response;
  }
  async function addSeller() {
    var s = await getSeller();
    if (s.data.length > 0) {
      toastify("SellerName already exists", "error");
      setSellerId("");
      setUserPassword("");
      s = [];
    } else {
      axios.post(
        `${BaseURL}AddSeller`,
        {
          sellerId,
          businessName,
          ownerName,
          aadharNumber,
          phNumber,
          email,
          address,
        },
        {
          headers: { Authorization: "Bearer " + sessionStorage.getItem("pic") },
        }
      );
      axios.post(
        `${BaseURL}registerNewSeller`,
        {
          email,
          name: ownerName,
          userName: sellerId,
          userPassword,
        },
        {
          headers: { Authorization: "Bearer " + sessionStorage.getItem("pic") },
        }
      );
      toastify("Seller Added Successfully", "success");
    }
    setSellerId("");
    setBusinessName("");
    setOwnerName("");
    setAadharNumber("");
    setPhNumber("");
    setEmail("");
    setAddress("");
    setUserPassword("");
  }
  return (
    <>
      <section id="hero">
        <div className="hero-container">
          <div className="hero-logo row">
            <h1 className="font-weight-bold col">Add Seller</h1>
          </div>
        </div>
      </section>
      <div className="form-container" id="mainform">
        <form action="" className="checkout-form">
          <div className="input-line">
            <label htmlFor="companyName">Company/Business Name</label>
            <input
              type="text"
              name="companyName"
              id="companyName"
              placeholder="Name of the Company"
              value={businessName}
              onChange={(e) => setBusinessName(e.target.value)}
            />
          </div>
          <div className="input-line">
            <label htmlFor="ownerName">Owner Name</label>
            <input
              type="text"
              name="ownerName"
              id="ownerName"
              placeholder="Name of the Owner"
              value={ownerName}
              onChange={(e) => setOwnerName(e.target.value)}
            />
          </div>
          <div className="input-line">
            <label htmlFor="AdhaarNumber">Adhaar Number</label>
            <input
              type="number"
              name="AdhaarNumber"
              id="AdhaarNumber"
              placeholder="Adhaar Number of the Owner"
              value={aadharNumber}
              onChange={(e) => setAadharNumber(e.target.value)}
            />
          </div>
          <div className="input-line">
            <label htmlFor="phonenumber">Phone Number</label>
            <input
              type="number"
              name="phonenumber"
              id="phonenumber"
              placeholder="Contact Number of the Company"
              value={phNumber}
              onChange={(e) => setPhNumber(e.target.value)}
            />
          </div>
          <div className="input-line">
            <label htmlFor="email">Email</label>
            <input
              type="text"
              name="email"
              id="email"
              placeholder="Email of the Company"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div className="input-line">
            <label htmlFor="address">Address</label>
            <input
              type="text"
              name="address"
              id="address"
              placeholder="Address of the Company"
              value={address}
              onChange={(e) => setAddress(e.target.value)}
            />
          </div>
          <div className="input-container">
            <div className="input-line">
              <label htmlFor="userName">Username</label>
              <input
                type="text"
                name="userName"
                id="userName"
                placeholder="User Name for the Seller"
                value={sellerId}
                onChange={(e) => setSellerId(e.target.value)}
              />
            </div>
            <div className="input-line">
              <label htmlFor="password">Password</label>
              <input
                type="text"
                name="password"
                id="password"
                placeholder="Password for the Seller"
                value={userPassword}
                onChange={(e) => setUserPassword(e.target.value)}
              />
            </div>
          </div>
          <div style={{ paddingBottom: "50px", paddingTop: "10px" }}>
            <div className="addseller">
              <button
                type="button"
                className="btn btn-success addsellerbtn"
                onClick={() => addSeller()}
              >
                Add Seller
              </button>
            </div>
          </div>
        </form>
      </div>
    </>
  );
};

export default AddSeller;
